import styled from 'styled-components';
import {
  PopoverOnboarding,
  spacer24,
  Type,
  ButtonTertiary,
} from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';

const StyledPopoverOnboarding = styled(PopoverOnboarding)`
  position: absolute;
  margin-top: ${spacer24};
  z-index: 1;
`;

interface OnboardingPopoverThreeProps {
  onCompleteOnboarding: () => void;
}

export const OnboardingPopoverThree = ({
  onCompleteOnboarding,
}: OnboardingPopoverThreeProps) => {
  const t = useT();

  return (
    <StyledPopoverOnboarding
      data-testid="onboarding"
      id="onboardingStepThree"
      arrow="topStart"
      popoverTitle={t(
        'atlas.catalog_exports.walk_through.name_your_export',
        'Name your export',
        'Title of walkthrough popover',
      )}
      colorSet="mutedAccent"
      onClose={() => onCompleteOnboarding()}
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      paginationText={
        <Type as="p" semanticColor="textSubdued" variant="finale">
          {t(
            'atlas.walk_through.three_of_three',
            '3 of 3',
            'Indicates this is three of three directions. 3 and 3 should be kept as numbers',
          )}
        </Type>
      }
      footerButton={
        <ButtonTertiary
          condensed
          size="small"
          onClick={() => {
            onCompleteOnboarding();
          }}
        >
          {t(
            'atlas.actions.done',
            'Done',
            'Button that indicates user is done',
          )}
        </ButtonTertiary>
      }
    >
      {t(
        'atlas.catalog_exports.walk_through.default_export_name',
        `By default, we'll name your export by the export type and date range. Optionally, you can add your own custom export name.`,
        'Text in walkthrough popover',
      )}
    </StyledPopoverOnboarding>
  );
};
